import React from 'react';
import BrandPage from './BrandPage';

const StiebelPage = () => <BrandPage brandSlug="stiebel" />;

export default StiebelPage;
